import React from 'react'
import PropTypes from 'prop-types'

function ProductEditPage(props) {
    return (
        <div>
            
        </div>
    )
}

ProductEditPage.propTypes = {

}

export default ProductEditPage

